import PropTypes from 'prop-types';

import Anchor from '../typography/anchor';
import twitter from '../../images/icons/twitter.svg';
import facebook from '../../images/icons/facebook.svg';
import tumblr from '../../images/icons/tumblr.svg';
import linkedin from '../../images/icons/linkedin.svg';
import whatsapp from '../../images/icons/whatsapp.svg';
import google from '../../images/icons/google.svg';
import mail from '../../images/icons/mail.svg';

import config from 'siteconfig';

import { social } from './shareblock.module.scss';

const ShareBlock = ({ pathname, text }) => {
  const fullUrl = new URL(pathname, config.siteUrl).href;
  const urlSafeText = encodeURIComponent(text);
  return (
    <div className={social}>
      <Anchor
        href={`https://twitter.com/intent/tweet?url=${fullUrl}&text=${urlSafeText}&related=resistbot`}
      >
        <img src={twitter} alt="Twitter" />
      </Anchor>
      <Anchor href={`https://www.facebook.com/sharer.php?u=${fullUrl}`}>
        <img src={facebook} alt="Facebook" />
      </Anchor>
      <Anchor href={`https://www.linkedin.com/shareArticle?url=${fullUrl}`}>
        <img src={linkedin} alt="LinkedIn" />
      </Anchor>
      <Anchor
        href={`https://api.whatsapp.com/send?phone=whatsappphonenumber&text=${urlSafeText}+${fullUrl}`}
      >
        <img src={whatsapp} alt="WhatsApp" />
      </Anchor>
      <Anchor
        href={`https://www.tumblr.com/widgets/share/tool?canonicalUrl=${fullUrl}&caption=${urlSafeText}`}
      >
        <img src={tumblr} alt="Tumblr" />
      </Anchor>
      <Anchor
        href={`https://mail.google.com/mail/u/0/?fs=1&to&su=&body=${fullUrl}&ui=2&tf=cm`}
      >
        <img src={google} alt="Google" />
      </Anchor>
      <Anchor href={`mailto:?subject=${urlSafeText}&body=${fullUrl}`}>
        <img src={mail} alt="Email" />
      </Anchor>
    </div>
  );
};

ShareBlock.propTypes = {
  pathname: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export { ShareBlock };
